import { CHARTER_COLORS as theme } from "../../shared/controleTheme";
import { printReportButtonStyle } from "../bisLayoutStyles";
import {
    preProductionLockedBadgeStyle,
    preProductionPatientCardHeaderStyle,
    preProductionPatientCardStyle,
    preProductionPatientChevronStyle,
    preProductionPatientToggleStyle,
} from "../bisPatientStyles";
import { renderPatientControleTab } from "./PatientControleTabView";
import { formatDateTime } from "../../shared/controleFormat";

export function renderInlinePatientControl(view) {
    const { blockingPatientIssues, controle, preProductionLocked, printControlePatientReport, setShowInlinePatientControl, showInlinePatientControl, validatedPatientCount, workspace } = view;
    return (
    <section style={preProductionPatientCardStyle}>
        <button
            type="button"
            onClick={() => setShowInlinePatientControl(open => !open)}
            aria-expanded={showInlinePatientControl}
            style={preProductionPatientToggleStyle}
        >
            <span style={{ display: "grid", gap: "4px", textAlign: "left", minWidth: 0 }}>
                <span style={{ color: theme.ink, fontSize: "17px", fontWeight: 950 }}>Contrôle patient</span>
                <span style={{ color: theme.muted, fontSize: "13px", fontWeight: 750 }}>
                    {validatedPatientCount}/{controle.patients.length} validés · {blockingPatientIssues.length} à reprendre
                </span>
            </span>
            <span style={{ display: "inline-flex", alignItems: "center", gap: "10px", flexWrap: "wrap", justifyContent: "flex-end" }}>
                {preProductionLocked && (
                    <span style={preProductionLockedBadgeStyle}>
                        Figé le {formatDateTime(workspace.formData.meta.preProductionValidatedAt)}
                    </span>
                )}
                <span style={preProductionPatientChevronStyle(showInlinePatientControl)}>
                    ›
                </span>
            </span>
        </button>
        {showInlinePatientControl && (
            <>
                <div style={preProductionPatientCardHeaderStyle}>
                    <div style={{ minWidth: 0 }}>
                        <h2 style={{ margin: 0, color: theme.ink, fontSize: "18px", fontWeight: 950 }}>Validation des patients</h2>
                        <div style={{ color: theme.muted, fontSize: "13px", marginTop: "4px" }}>
                            {validatedPatientCount}/{controle.patients.length} validés
                        </div>
                    </div>
                    <button
                        type="button"
                        onClick={printControlePatientReport}
                        style={printReportButtonStyle}
                    >
                        Imprimer rapport
                    </button>
                </div>
                {renderPatientControleTab(view)}
            </>
        )}
    </section>
    );
}
